import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { changePassword } from '../../services/authService';
import toast from 'react-hot-toast';

const fieldStyle = {
  width: '100%', boxSizing: 'border-box', padding: '11px 13px', borderRadius: 11,
  border: '1px solid var(--border)', background: 'var(--bg)', color: 'var(--text-1)',
  fontSize: 14, fontFamily: 'inherit', outline: 'none'
};
const labelStyle = { display: 'block', fontSize: 12, fontWeight: 600, color: 'var(--text-3)', marginBottom: 6 };

// Модалка смены пароля из профиля (текущий → новый → повтор).
const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) { setCurrent(''); setNext(''); setConfirm(''); setShow(false); }
  }, [isOpen]);

  const handleSave = async () => {
    if (!current) return toast.error('Введите текущий пароль');
    if (next.length < 6) return toast.error('Новый пароль должен быть не короче 6 символов');
    if (next !== confirm) return toast.error('Пароли не совпадают');
    if (next === current) return toast.error('Новый пароль совпадает со старым');
    setSaving(true);
    try {
      await changePassword(current, next);
      toast.success('Пароль изменён');
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Не удалось сменить пароль');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Сменить пароль" size="small">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div>
          <label style={labelStyle}>Текущий пароль</label>
          <input type={show ? 'text' : 'password'} value={current} onChange={e => setCurrent(e.target.value)}
            placeholder="••••••••" style={fieldStyle} autoComplete="current-password" />
        </div>
        <div>
          <label style={labelStyle}>Новый пароль</label>
          <input type={show ? 'text' : 'password'} value={next} onChange={e => setNext(e.target.value)}
            placeholder="Минимум 6 символов" style={fieldStyle} autoComplete="new-password" />
        </div>
        <div>
          <label style={labelStyle}>Повторите новый пароль</label>
          <input type={show ? 'text' : 'password'} value={confirm} onChange={e => setConfirm(e.target.value)}
            placeholder="••••••••" style={fieldStyle} autoComplete="new-password"
            onKeyDown={e => { if (e.key === 'Enter') handleSave(); }} />
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-2)', cursor: 'pointer' }}>
          <input type="checkbox" checked={show} onChange={e => setShow(e.target.checked)} />
          Показать пароли
        </label>

        <div style={{ display: 'flex', gap: 10, width: '100%', marginTop: 2 }}>
          <button type="button" onClick={onClose} disabled={saving}
            style={{ flex: 1, padding: '11px', borderRadius: 11, border: '1px solid var(--border)',
              background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit' }}>
            Отмена
          </button>
          <button type="button" onClick={handleSave} disabled={saving}
            style={{ flex: 1, padding: '11px', borderRadius: 11, border: 'none',
              background: 'var(--primary)', color: '#fff', cursor: saving ? 'not-allowed' : 'pointer',
              fontSize: 13, fontWeight: 700, fontFamily: 'inherit', opacity: saving ? 0.7 : 1 }}>
            {saving ? 'Сохранение…' : 'Сменить пароль'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangePasswordModal;
